import { ConnectedPosition } from '@angular/cdk/overlay';
import { Component } from '@angular/core';

import { LanguageService } from '../../../shared/services';

@Component({
  selector: 'customer-azzurro-inverter',
  templateUrl: './azzurro-inverter.component.html',
  styleUrls: ['./azzurro-inverter.component.scss'],
})
export class AzzurroInverterComponent {

  dashboardImages: string[] =  [
    'assets/images/screenshots/power-flows.png',
    'assets/images/screenshots/daily-state.png',
    'assets/images/screenshots/energy-overview.png',
    'assets/images/screenshots/self-consumption.png',
  ];
  dashboardImageIndex = 0;

  readonly currentLang$ = this.languageService.currentLang$;
  readonly tooltipsTemplatePosition: Partial<ConnectedPosition> = {
    originX: 'end',
    originY: 'bottom',
    overlayX: 'end',
    overlayY: 'top',
    offsetY: 4,
  };

  constructor(
    readonly languageService: LanguageService,
  ) { }

  nextImage(section: string): void {
    switch (section) {
      case 'dashboard':
        this.dashboardImageIndex =
          (this.dashboardImageIndex + 1) % this.dashboardImages.length;
        break;
    }
  }

  prevImage(section: string): void {
    switch (section) {
      case 'dashboard':
        this.dashboardImageIndex =
          (this.dashboardImageIndex - 1 + this.dashboardImages.length) %
          this.dashboardImages.length;
        break;
    }
  }
}
